<button
  mat-button
  [attr.blurOption]="BlurOption.PREVENT_BLUR"
  [matTooltip]="toolbarItem.tooltipText"
  matTooltipPosition="below"
  [matTooltipShowDelay]="tooltipDelay"
  (click)="openModal()"
  [disabled]="!enabled"
  [attr.aria-label]="toolbarItem.ariaLabel"
>
  <mat-icon *ngFor="let icon of toolbarItem.icons">{{ icon }}</mat-icon>
  <cars-alt-accessibility
    [altProperties]="altProperties"
    [richText]="true"
    (onSelect)="openModal()"
  ></cars-alt-accessibility>
</button>
